import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Nota: los meta tags de SEO (description, OG, Twitter) y JSON-LD schema.org
// se definen estáticamente en public/index.html para que los crawlers los
// vean sin necesidad de ejecutar JavaScript. No los sobreescribimos en runtime.

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Performance monitoring
reportWebVitals();
